import { Link } from 'gatsby';
import * as React from 'react';
import Helmet from 'react-helmet';
import FxLayout from '../components/shared/layout/layout';

export default class PartnerAnnouncementPage extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  } 

  render() {
    const { pageContext } = this.props;
    const partnerAnnouncement = pageContext.partnerAnnouncement;
    const advisers = pageContext.advisers;
    return (
      <FxLayout>
        <Helmet>
          <title>{partnerAnnouncement?.seoTitle}</title>
          <html lang="en" />
          <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover" />
          <meta key={partnerAnnouncement?.id} name="title" content={partnerAnnouncement?.seoTitle} />
          <meta key={partnerAnnouncement?.id} name="description" content={partnerAnnouncement?.seoDescription} />
          <meta key={partnerAnnouncement?.id} name="keywords" content={partnerAnnouncement?.seoKeywords} />
          <link rel="canonical" href={`${process.env.SITE_URL} / ${partnerAnnouncement?.year}-partners`} />
        </Helmet>

        <div className="fx-l-pa">
          <section className="fx-l-pa-hero"
            style={{
              backgroundImage: `url(https://media.graphassets.com/${partnerAnnouncement?.heroImage?.handle ? partnerAnnouncement?.heroImage?.handle : ''}
              )`}}
          >
            <div className="fx-l-pa-hero-container">
              <div className="fx-l-pa-hero-content">
                <h1>{partnerAnnouncement?.heroTitle}</h1>
              </div>
            </div>
          </section>

          <section className="fx-l-pa-body">
            <div className="fx-l-pa-heading-wrap">
              <h2 className="fx-l-pa-heading">
                {partnerAnnouncement?.heroSubtitle}
              </h2>
              <div className="fx-rich-text"
                dangerouslySetInnerHTML={{ __html: partnerAnnouncement?.pageBody.html }}
              />
            </div>
            <div className="pa-grid-wrap">
              {advisers &&
                advisers.map((adviser: any) => (
                  <div key={adviser.id} className="pa-partner">
                    <Link className="pa-overlay" to={`/${adviser.url}`}>
                      <span>View Profile</span>
                      <img src={adviser.partnerImage.url} alt="" />
                    </Link>
                    <div className="pa-info">
                      <h3>
                        {adviser.givenName} {adviser.surname}
                      </h3>
                      <h4>
                        {adviser.adviserTitle.title}, {adviser.mainOffice.name}
                      </h4>
                      <h4>
                        <span className="pa-partner-serviceline">{adviser.partnerServiceLine}</span>
                      </h4>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        </div>

        <div className="fx-l-pa-footer">
          <div className="fx-l-pa-footer-container">
            <h2>Grow with us</h2>
            <h4>
              We welcome the opportunity to assist you in finding solutions to your challenges.
              <br />
              <a href={`/contact-us`}>Let us help you get started.</a>
            </h4>
          </div>
        </div>
      </FxLayout>
    );
  }
}
